@if (state().status === 'loading') {
  <section class="product-missing">
    <div class="max-w-3xl mx-auto px-4 text-center">
      <p>Loading product…</p>
    </div>
  </section>
} @else if (product(); as p) {
  <article class="product-page" [style.--accent]="p.color">
    <div class="product-page__bg"></div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <a routerLink="/" fragment="projects" class="product-back">
        <i class="pi pi-arrow-left"></i>
        Back to projects
      </a>

      <div class="product-layout">
        <div class="product-main">
          <header class="product-header">
            <p class="product-eyebrow">Product overview</p>
            <h1>{{ p.title }}</h1>
            <p class="product-meta">
              <span>{{ p.category }}</span>
              <span class="product-meta__dot" aria-hidden="true"></span>
              <span>{{ p.tagline }}</span>
            </p>
          </header>

          @if (media().length) {
            <div class="product-carousel" aria-label="Product screenshots">
              <div class="product-carousel__frame">
                @for (item of media(); track item.src; let i = $index) {
                  <img
                    [src]="item.src"
                    [alt]="item.alt"
                    class="product-carousel__slide"
                    [class.is-active]="activeMedia() === i"
                  />
                }

                @if (media().length > 1) {
                  <button type="button" class="carousel-nav carousel-nav--prev" (click)="prevMedia()" aria-label="Previous image">
                    <i class="pi pi-chevron-left"></i>
                  </button>
                  <button type="button" class="carousel-nav carousel-nav--next" (click)="nextMedia()" aria-label="Next image">
                    <i class="pi pi-chevron-right"></i>
                  </button>
                }
              </div>

              @if (media().length > 1) {
                <div class="carousel-dots" role="tablist" aria-label="Screenshot navigation">
                  @for (item of media(); track item.src; let i = $index) {
                    <button
                      type="button"
                      class="carousel-dot"
                      [class.is-active]="activeMedia() === i"
                      (click)="goToMedia(i)"
                      [attr.aria-label]="'Show image ' + (i + 1)"
                    ></button>
                  }
                </div>
              }
            </div>
          }

          <section class="product-section">
            <p class="product-lede">{{ p.overview }}</p>
          </section>

          <section class="product-section">
            <h2>Features</h2>
            <ul class="feature-list">
              @for (item of p.features; track item) {
                <li>
                  <i class="pi pi-check-circle"></i>
                  <span>{{ item }}</span>
                </li>
              }
            </ul>
          </section>

          <section class="product-section">
            <h2>Platforms supported</h2>
            <div class="chip-row">
              @for (platform of p.platforms; track platform) {
                <span class="chip">{{ platform }}</span>
              }
            </div>
          </section>

          <section class="product-section">
            <h2>Built with</h2>
            <div class="chip-row">
              @for (tech of p.stack; track tech) {
                <span class="chip chip--stack">{{ tech }}</span>
              }
            </div>
          </section>
        </div>

        <aside class="product-sidebar">
          <div class="sidebar-panel sidebar-panel--about">
            <h3>About</h3>
            <p>{{ p.description }}</p>
            <a
              class="sidebar-cta"
              [href]="p.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit live site
              <i class="pi pi-arrow-up-right"></i>
            </a>
          </div>

          @if (related().length) {
            <div class="sidebar-panel">
              <h3>More products</h3>
              <ul class="sidebar-posts">
                @for (item of related(); track item.slug) {
                  <li>
                    <a [routerLink]="['/products', item.slug]" class="sidebar-post">
                      @if (item.preview) {
                        <img [src]="item.preview" [alt]="''" />
                      }
                      <span>
                        <strong>{{ item.title }}</strong>
                        <small>{{ item.category }}</small>
                      </span>
                    </a>
                  </li>
                }
              </ul>
            </div>
          }

          <div class="sidebar-panel">
            <h3>Links</h3>
            <ul class="sidebar-links">
              <li>
                <a [href]="p.url" target="_blank" rel="noopener noreferrer">Live website</a>
              </li>
              @if (p.iosUrl) {
                <li>
                  <a [href]="p.iosUrl" target="_blank" rel="noopener noreferrer">App Store</a>
                </li>
              }
              @if (p.androidUrl) {
                <li>
                  <a [href]="p.androidUrl" target="_blank" rel="noopener noreferrer">Google Play</a>
                </li>
              }
              <li>
                <a routerLink="/" fragment="contact">Contact Trieon</a>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  </article>
} @else {
  <section class="product-missing">
    <div class="max-w-3xl mx-auto px-4 text-center">
      <h1>Product not found</h1>
      <p>That product page does not exist.</p>
      <a routerLink="/" fragment="projects" class="sidebar-cta">Back to projects</a>
    </div>
  </section>
}
